export default {
  simulation: {
    header: 'Simulation',
    secondsPerCalculationStepLabel: 'Auflösung',
    secondsPerCalculationStepDescription: 'Simulierte Zeit zwischen zwei aufeinander folgenden Berechnungsschritten',
    factorOnCBetaLabel: 'Faktor auf C-Beta',
    factorOnCBetaDescription: 'Kohlenstoffübertragungskoeffizient anpassen',
    factorOnCDiffCoeffLabel: 'Faktor auf C-Diff-Coeff',
    factorOnCDiffCoeffDescription: 'Kohlenstoffdiffusionskoeffizient anpassen',
    timeoutSeconds: 'Maximale Simulationszeit',
  },
  lowPressureCarburizingOnly: {
    header: 'Nur Niederdruckaufkohlung',
    maxCInCementiteLabel: 'Max. C in Zementit',
    maxCInCementiteDescription: 'Obere Grenze für die automatische Boost-Hysterese',
    cBelowCarbidelimitLabel: 'C unter Carbidelimit',
    cBelowCarbidelimitDescription: 'Untere Grenze für die automatische Boost-Hysterese',
  },
  showComponentSelectionWhenLoadingCheckbox: 'Komponentenauswahl beim Laden anzeigen',
};
